import { Component, forwardRef, Input, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalizedDatePipe } from '../../../../core/locale/localized-date.pipe';

const CUSTOM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => DateInputComponent),
  multi: true,
};

@Component({
    selector: 'odq-date-input',
    providers: [CUSTOM_VALUE_ACCESSOR],
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss'],
    standalone: false
})
export class DateInputComponent implements ControlValueAccessor, OnDestroy {
  @Input() placeholder;
  @Input() min;
  @Input() clearable = true;
  @Input() badge;
  @ViewChild('inputField', { static: true }) inputField;

  destroy$ = new Subject<void>();

  public inputValue: string;
  private disabled: boolean;
  // tslint:disable-next-line: ban-types
  private onChange: Function;
  // tslint:disable-next-line: ban-types
  private onTouched: Function;

  constructor(private datePipe: LocalizedDatePipe, private translate: TranslateService, private renderer: Renderer2) {
    this.onChange = (_: any) => { };
    this.onTouched = () => { };
    this.disabled = false;

    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const inputTag = this.inputField.nativeElement;
        this.renderer.setProperty(inputTag, 'value', this.getLocalizedDate());
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clear(): void {
    this.updateValue(null);
  }

  updateValue($event) {
    const value = $event?.value ?? null;
    this.inputValue = value;
    this.writeValue(value);
    this.onChange(this.inputValue);
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.inputValue = obj;
    const inputTag = this.inputField.nativeElement;
    this.renderer.setProperty(inputTag, 'value', this.getLocalizedDate());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private getLocalizedDate(): string {
    return this.datePipe.transform(this.inputValue);
  }
}
